import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import cx from 'classnames';
import omit from 'omit';
import AntButton from 'antd/lib/button';
var Button = /*#__PURE__*/React.memo(props => /*#__PURE__*/React.createElement(AntButton, _extends({
  className: cx('sk-button', props.className, {
    primary: props.type === 'primary',
    large: props.size === 'large',
    disable: props.disabled
  })
}, omit(['className'], props))));
export default Button;